import { VueAvatar } from 'vue-avatar-editor-improved'

/**
 * @desc add method clear in "VueAvatar" component and init
 */
VueAvatar.mounted = function () {
  let self = this
  self.$refs.input.setAttribute('accept', 'image/x-png,image/jpeg')
  this.canvas = this.$refs.avatarEditorCanvas
  this.context = this.canvas.getContext('2d')
  this.paint()

  if (!this.image) {
    self.renderPlaceholder()
  } else {
    this.loadImage(this.image)
  }
}
VueAvatar.methods.renderPlaceholder = function () {
  let self = this
  let placeHolder = self.svgToImage('<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65 65"><defs><style>.cls-1{fill:#000;}</style></defs><title>Upload_Upload</title><path class="cls-1" d="M32.5,1A31.5,31.5,0,1,1,1,32.5,31.54,31.54,0,0,1,32.5,1m0-1A32.5,32.5,0,1,0,65,32.5,32.5,32.5,0,0,0,32.5,0h0Z"/><polygon class="cls-1" points="41.91 28.2 32.59 18.65 23.09 28.39 24.17 29.44 31.87 21.54 31.87 40.05 33.37 40.05 33.37 21.59 40.83 29.25 41.91 28.2"/><polygon class="cls-1" points="40.66 40.35 40.66 44.35 24.34 44.35 24.34 40.35 22.34 40.35 22.34 44.35 22.34 46.35 24.34 46.35 40.66 46.35 42.66 46.35 42.66 44.35 42.66 40.35 40.66 40.35"/></svg>')
  placeHolder.onload = function () {
    let x = self.canvasWidth / 2 - this.width / 2
    let y = self.canvasHeight / 2 - this.height / 2
    self.context.drawImage(placeHolder, x, y, this.width, this.height)
  }
}
VueAvatar.methods.resetImage = function () {
  let self = this
  this.canvas = this.$refs.avatarEditorCanvas
  this.context = this.canvas.getContext('2d')
  self.imageLoaded = false
  this.$emit('imageLoaded', self.imageLoaded)
  self.state = {
    drag: false,
    my: null,
    mx: null,
    xxx: 'ab',
    image: {
      x: 0,
      y: 0,
      resource: null
    }
  }
  this.context.clearRect(0, 0, this.getDimensions().canvas.width, this.getDimensions().canvas.height)
  this.paint()
  self.renderPlaceholder()
}

export default VueAvatar
